import React, { useState } from 'react';
import { mockData } from '../mock';
import { Card, CardContent } from './ui/card';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % mockData.testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + mockData.testimonials.length) % mockData.testimonials.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-6 py-2 bg-[#F5F3ED] rounded-full text-[#1A3A2E] text-sm font-medium mb-6">
            Kundenstimmen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A3A2E] mb-4">
            Zufriedene Kunden der Firma Novatus Energie
          </h2>
          <p className="text-lg text-[#1A3A2E]/70 max-w-4xl mx-auto">
            Hören Sie von zufriedenen Kunden von Novatus, die Ihr Energiesystem im Haus mit uns effizienter gemacht haben
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {mockData.testimonials.map((testimonial, idx) => (
                <div key={idx} className="min-w-full px-4">
                  <Card className="border-none shadow-2xl">
                    <CardContent className="p-12">
                      <div className="flex flex-col md:flex-row items-center md:items-start space-y-6 md:space-y-0 md:space-x-8">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="w-32 h-32 rounded-full object-cover shadow-lg"
                        />
                        <div className="flex-1">
                          <p className="text-xl text-[#1A3A2E] leading-relaxed mb-6 italic">
                            "{testimonial.text}"
                          </p>
                          <div>
                            <p className="font-bold text-[#1A3A2E] text-lg">{testimonial.name}</p>
                            <p className="text-[#1A3A2E]/70">{testimonial.location}</p>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-center mt-8 space-x-4">
            <Button
              onClick={prevTestimonial}
              variant="outline"
              size="icon"
              className="rounded-full border-2 border-[#1A3A2E] hover:bg-[#1A3A2E] hover:text-white"
            >
              <ChevronLeft className="w-5 h-5" />
            </Button>
            <Button
              onClick={nextTestimonial}
              variant="outline"
              size="icon"
              className="rounded-full border-2 border-[#1A3A2E] hover:bg-[#1A3A2E] hover:text-white"
            >
              <ChevronRight className="w-5 h-5" />
            </Button>
          </div>

          <div className="flex justify-center mt-6 space-x-2">
            {mockData.testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIndex(idx)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  idx === currentIndex ? 'bg-[#1A3A2E] w-8' : 'bg-[#1A3A2E]/30'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;